<template>
  <table role="presentation" cellpadding="0" cellspacing="0" border="0" style="border-collapse: collapse;" :style="{ 'font-family': data.font }">
    <tbody>
      <tr>
        <!-- left column: image -->
        <td valign="top">
          <div v-if="data.imageUrl" style="text-align: left; margin-right: 16px;">
            <img
              :src="data.imageUrl"
              alt=""
              :style="data._placeholderFields?.has?.('imageUrl')
                ? {
                    width: '90px',
                    height: 'auto',
                    borderRadius: '16px',
                    objectFit: 'contain',
                    objectPosition: 'top center',
                    display: 'block'
                  }
                : {
                    display: 'block',
                    maxWidth: '90px',
                    maxHeight: '90px',
                    borderRadius: '16px',
                    width: 'auto',
                    height: 'auto'
                  }"
            />
          </div>
        </td>

        <!-- right column -->
        <td valign="top" style="padding: 0;">
          <table>
            <tbody>
              <tr>
                <td>
                  <div
                    v-if="data.displayName"
                    style="
                      font-style: normal;
                      font-weight: 500;
                      line-height: normal;
                    "
                    :style="{ fontSize: useFontSizeScale(20).value }"
                  >
                    <span>{{ data.displayName }}</span>
                  </div>
                </td>
              </tr>

              <tr>
                <td>
                  <div
                    v-if="data.profession"
                    :style="{
                      'background-color': data.theme?.background,
                      color: data.theme?.text,
                    }"
                    style="
                      display: inline-block;
                      align-content: center;
                      width: fit-content;
                      border-radius: 24px;
                      padding: 2px 8px;
                      padding: 4px 12px;
                      margin: 8px 0 4px 0;
                      word-break: break-all;
                    "
                  >
                    <span
                      style="font-style: normal; font-weight: 500; line-height: normal;"
                      :style="{ fontSize: useFontSizeScale(12).value }"
                    >
                      {{ data.profession }}
                    </span>
                  </div>
                </td>
              </tr>

              <tr>
                <td>
                  <div
                    style="line-height: 1.2; font-weight: 400;"
                    :style="{ fontSize: useFontSizeScale(12).value }"
                  >
                    <div v-if="data.company" style="margin-top: 4px;">
                      {{ data.company }}
                    </div>
                    <div v-if="data.website" style="margin-top: 4px;">
                      <a v-if="data.website" target="_blank" :href="data.website.startsWith('http') ? data.website : 'https://' + data.website"
                      style="color: inherit; text-decoration: none;"
                    >
                        {{ data.website }}
                      </a>
                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td>
                  <div
                    style="font-style: normal; font-weight: 500; line-height: 1.2;"
                    :style="{ fontSize: useFontSizeScale(12).value }"
                  >
                    <table
                      v-if="data.chat || data.instagram || data.facebook || data.linkedin || data.youtube || data.x"
                      role="presentation"
                      cellspacing="0"
                      cellpadding="0"
                      border="0"
                      style="border-collapse: collapse; margin-top: 12px;"
                    >
                      <tbody>
                        <tr>
                          <td v-if="data.chat && data.chatIconUrl" style="padding-right: 12px;">
                            <table role="presentation" cellspacing="0" cellpadding="0" border="0">
                              <tbody>
                                <tr>
                                  <td width="16" height="16" style="width: 16px; height: 16px; line-height:0; mso-line-height-rule: exactly;">
                                    <a
                                      :href="data.chat"
                                      target="_blank"
                                      style="display: inline-block; text-decoration: none; padding: 6px; border-radius: 24px; min-width: 16px; min-height: 16px;"
                                      :style="{ 'background-color': data.theme?.background || '#EFF0F5' }"
                                    >
                                      <img
                                        :src="data.chatIconUrl"
                                        alt="Chat"
                                        style="display: block; width: 16px; height:16px; border:0; outline:none;"
                                      />
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>

                          <td v-if="data.instagram && data.instagramIconUrl" style="padding-right: 12px;">
                            <table role="presentation" cellspacing="0" cellpadding="0" border="0">
                              <tbody>
                                <tr>
                                  <td width="16" height="16" style="width: 16px; height: 16px; line-height: 0; mso-line-height-rule: exactly;">
                                    <a
                                      :href="'https://www.instagram.com/' + data.instagram"
                                      target="_blank"
                                      style="display: inline-block; text-decoration: none; padding: 6px; border-radius: 24px; min-width: 16px; min-height: 16px;"
                                      :style="{ 'background-color': data.theme?.background || '#EFF0F5' }"
                                    >
                                      <img
                                        :src="data.instagramIconUrl"
                                        alt="Instagram"
                                        style="display: block; width: 16px; height: 16px; border: 0; outline: none;"
                                      />
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>

                          <td v-if="data.facebook && data.facebookIconUrl" style="padding-right: 12px;">
                            <table role="presentation" cellspacing="0" cellpadding="0" border="0">
                              <tbody>
                                <tr>
                                  <td width="16" height="16" style="width: 16px; height: 16px; line-height: 0; mso-line-height-rule: exactly;">
                                    <a
                                      :href="'https://www.facebook.com/' + data.facebook"
                                      target="_blank"
                                      style="display: inline-block; text-decoration: none; padding: 6px; border-radius: 24px; min-width: 16px; min-height: 16px;"
                                      :style="{ 'background-color': data.theme?.background || '#EFF0F5' }"
                                    >
                                      <img
                                        :src="data.facebookIconUrl"
                                        alt="Facebook"
                                        style="display: block; width: 16px; height: 16px; border: 0; outline: none;"
                                      />
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>

                          <td v-if="data.linkedin && data.linkedinIconUrl" style="padding-right: 12px;">
                            <table role="presentation" cellspacing="0" cellpadding="0" border="0">
                              <tbody>
                                <tr>
                                  <td width="16" height="16" style="width: 16px; height: 16px; line-height: 0; mso-line-height-rule: exactly;">
                                    <a
                                      :href="'https://www.linkedin.com/in/' + data.linkedin"
                                      target="_blank"
                                      style="display: inline-block; text-decoration: none; padding: 6px; border-radius: 24px; min-width: 16px; min-height: 16px;"
                                      :style="{ 'background-color': data.theme?.background || '#EFF0F5' }"
                                    >
                                      <img
                                        :src="data.linkedinIconUrl"
                                        alt="LinkedIn"
                                        style="display: block; width: 16px; height: 16px; border: 0; outline: none;"
                                      />
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>

                          <td v-if="data.youtube && data.youtubeIconUrl" style="padding-right: 12px;">
                            <table role="presentation" cellspacing="0" cellpadding="0" border="0">
                              <tbody>
                                <tr>
                                  <td width="16" height="16" style="width: 16px; height: 16px; line-height: 0; mso-line-height-rule: exactly;">
                                    <a
                                      :href="'https://www.youtube.com/@' + data.youtube"
                                      target="_blank"
                                      style="display: inline-block; text-decoration: none; padding: 6px; border-radius: 24px; min-width: 16px; min-height: 16px;"
                                      :style="{ 'background-color': data.theme?.background || '#EFF0F5' }"
                                    >
                                      <img
                                        :src="data.youtubeIconUrl"
                                        alt="YouTube"
                                        style="display: block; width: 16px; height: 16px; border: 0; outline: none;"
                                      />
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>

                          <td v-if="data.x && data.xIconUrl" style="padding-right: 12px;">
                            <table role="presentation" cellspacing="0" cellpadding="0" border="0">
                              <tbody>
                                <tr>
                                  <td width="16" height="16" style="width: 16px; height: 16px; line-height: 0; mso-line-height-rule: exactly;">
                                    <a
                                      :href="'https://www.x.com/' + data.x"
                                      target="_blank"
                                      style="display: inline-block; text-decoration: none; padding: 6px; border-radius: 24px; min-width: 16px; min-height: 16px;"
                                      :style="{ 'background-color': data.theme?.background || '#EFF0F5' }"
                                    >
                                      <img
                                        :src="data.xIconUrl"
                                        alt="X (Twitter)"
                                        style="display: block; width: 16px; height: 16px; border: 0; outline: none;"
                                      />
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>

              <tr v-if="data.disclaimer">
                <td>
                  <div
                    style="
                      font-style: normal;
                      font-weight: 400;
                      color: #707070;
                      line-height: 16px;
                      margin-top: 16px;
                      word-break: break-word;
                    "
                    :style="{ fontSize: useFontSizeScale(11).value }"
                  >
                    {{ data.disclaimer }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup>
import { useFontSizeScale } from '@/io.ox/mail/settings/signatures/signature-designer/composables/useFontSizeScale'

const availableFields = [
  'company',
  'website',
  'disclaimer',
  'displayName',
  'imageUrl',
  'profession',
  'theme',
  'facebook',
  'instagram',
  'youtube',
  'linkedin',
  'x',
  'chat',
  'font',
  'fontSize'
]

defineProps({
  data: { type: Object, required: true }
})

defineExpose({
  availableFields,
  imageSlots: [
    { field: 'imageUrl', aspect: 'square' },
  ],
  previewTheme: { background: '#000000', text: 'white' }
})
</script>
